export const FEEDBACK_MESSAGE_TABLE = "feedbackMessages"
export const FEEDBACK_MESSAGE_TABLE_SCHEMA =
  "id, companyId, feedbackId, authorUserId, syncId, createdAt"
